// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductLinkageModal_root__gbe7h","titleModal":"ProductLinkageModal_titleModal__2kbj6"};